import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useForm, Controller } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import queryString from "query-string"
import "./form.css";
import {
  eventClick,
  eventWithFormInfo,
  formAbandonEvent,
  formIntermediateEventOTP,
  formStarts,
  formSubmissionFailEvent,
  formSubmitEvent,
  submitErrorEvent,
} from "../services/adobeDataLayer.js";
import { formatAndValidateE164, hashValue, normalizeEmail, setValuesInLocalStorange } from "../services/utils.js";
import {
  callLSQLapp,
  encryptBody,
  getFirstNameLastName,
  getLsqLeadBody,
} from "../services/lsq.js";

let cancelToken;
let lastFetchedPrefix = "";
let collegeCancelToken;
let lastFetchedCollegePrefix = "";

function FormComponent() {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    setValue,
    getValues,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    defaultValues: {
      // residentialStatus: ["Fixed Deposit"] // default selected
    }
  });


  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [timer, setTimer] = useState(60);
  const [email, setEmail] = useState("");
  const [isEmailEmpty, setIsEmailEmpty] = useState();


  const [token, setToken] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [employerName, setEmployerName] = useState("");
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [gcc, setGcc] = useState("");
  const [ppaCode, setPPACode] = useState("");
  const [topCorporate, settopCorporate] = useState("");
  const [otherCompanyName, setOtherCompanyName] = useState("");
  const [collegeName, setCollegeName] = useState("");
  const [colleges, setColleges] = useState([]);
  const [collegeGcc, setCollegeGcc] = useState("");
  const collegeSelectedFromDropdown = useRef(false);
  const companySelectedRef = useRef(false);
  const [solId, setSolId] = useState("");
  const [pincodeData, setPincodeData] = useState({ Branch_Name: "", City: "", State: "", State2: "", assignToDista: "", negativePincode: "", salaryToSavingsCheck: "", savingsNegativePincode: "" });
  const companyWrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutsideCompany = (event) => {
      if (
        companyWrapperRef.current &&
        !companyWrapperRef.current.contains(event.target)
      ) {
        setCompanies([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideCompany);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideCompany);
    };
  }, []);

  const lastAccessedFieldRef = useRef("");
  const formStartedRef = useRef(false);
  const validPincodeRef = useRef(null); // null=unchecked, true=valid, false=invalid

  // Listen for CTA clicks from external components (Footer, FAQ, etc.) and fire abandon if form was started
  useEffect(() => {
    const handleExternalCTA = () => {
      if (formStartedRef.current) {
        formAbandonEvent(lastAccessedFieldRef.current);
        formStartedRef.current = false;
      }
    };
    window.addEventListener("adobeCTAClick", handleExternalCTA);
    return () => window.removeEventListener("adobeCTAClick", handleExternalCTA);
  }, []);

  const onInvalidSubmit = (formErrors) => {
    const flatErrors = Object.fromEntries(
      Object.entries(formErrors).map(([key, err]) => [key, err.message])
    );
    submitErrorEvent(flatErrors);
  };

  const trackFormStart = () => {
    if (!formStartedRef.current) {
      formStarts();
      formStartedRef.current = true;
    }
  };

  const handleFieldFocus = (fieldName) => {
    lastAccessedFieldRef.current = fieldName;
    trackFormStart();
  };

  const { onChange: handleChange, ...companyRegisterProps } = register("companyName", {
    required: "This field is required",
    validate: () => companySelectedRef.current || "Please select your employer from the suggestions",
  });

  const onCompanyChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = searchValue.substring(0, 4).toLowerCase();
    const storageKey = `salCorp_${prefix}`;

    setEmployerName(inputValue);
    handleChange(e);
    companySelectedRef.current = false;
    setGcc("");
    setPPACode("");

    const addOthersIfNeeded = (list) => {
      const seen = new Set();
      const dedupedList = list.filter((item) => {
        if (seen.has(item.Company_Name)) return false;
        seen.add(item.Company_Name);
        return true;
      });
      const hasExactMatch = dedupedList.some(
        (item) => item.Company_Name.toLowerCase() === searchValue.toLowerCase()
      );
      if (!hasExactMatch && searchValue.length > 0) {
        return [...dedupedList, { Company_Name: "Others", LTF: null }];
      }
      return dedupedList;
    };

    const storedData = localStorage.getItem(storageKey);
    const parsedData = storedData ? JSON.parse(storedData) : null;
    // cached entries fetched before PPA_Code support was added won't have the field; treat those as stale so they get refetched
    const isCacheStale =
      parsedData &&
      parsedData.some((item) => item.Company_Name !== "Others" && !("PPA_Code" in item));
    if (isCacheStale) {
      localStorage.removeItem(storageKey);
    }

    if (parsedData && !isCacheStale) {
      const filteredData = parsedData.filter((item) =>
        item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      const finalData = addOthersIfNeeded(filteredData);
      setCompanies(finalData);
    } else if (prefix.length >= 3 && prefix !== lastFetchedPrefix) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Cancelled due to new request");
      }
      cancelToken = axios.CancelToken.source();

      try {
        const payload = { company: searchValue };
        const param = { type: "salCorpNewGCC" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;

        if (Count > 0) {
          localStorage.setItem(storageKey, JSON.stringify(Data));
          lastFetchedPrefix = prefix;
          const filteredData = Data.filter((item) =>
            item.Company_Name.toLowerCase().startsWith(searchValue.toLowerCase())
          );
          const finalData = addOthersIfNeeded(filteredData);
          setCompanies(finalData);
        } else {
          localStorage.setItem(storageKey, JSON.stringify([]));
          lastFetchedPrefix = prefix;
          setCompanies([{ Company_Name: "Others", LTF: null }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("Company fetch failed:", error);
        }
      }
    } else {
      setCompanies([]);
    }

    const hasExactMatchInDropdown = companies.some(
      (item) => item.Company_Name.toLowerCase() === searchValue.toLowerCase()
    );

    if (searchValue.length >= 3 && !hasExactMatchInDropdown) {
      setShowOtherInput(true);
      setValue("companyName", "Others");
      setValue("otherCompanyName", inputValue);
      setGcc("Others");
    } else {
      setShowOtherInput(false);
    }
  };

  const onCollegeChange = async (e) => {
    const inputValue = e.target.value;
    const searchValue = inputValue.trim();
    const prefix = "salcorp_coll_" + searchValue.substring(0, 4).toLowerCase();

    setCollegeName(inputValue);
    setCollegeGcc("");
    collegeSelectedFromDropdown.current = false;

    const addCollegeOthers = (list) => {
      const hasOthers = list.some((item) => item.Institute_Name === "Others");
      if (!hasOthers && searchValue.length > 0) {
        return [...list, { Institute_Name: "Others" }];
      }
      return list;
    };

    const storedData = localStorage.getItem(prefix);
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      const filtered = parsedData.filter((item) =>
        item.Institute_Name.toLowerCase().startsWith(searchValue.toLowerCase())
      );
      setColleges(addCollegeOthers(filtered));
    } else if (searchValue.length >= 3 && prefix !== lastFetchedCollegePrefix) {
      if (typeof collegeCancelToken !== typeof undefined) {
        collegeCancelToken.cancel("Cancelled due to new request");
      }
      collegeCancelToken = axios.CancelToken.source();
      try {
        const payload = { company: searchValue };
        const param = { type: "savingsCollege" };
        const response = await callLSQLapp(payload, "MAVIS", param);
        const { Data, Count } = response.data.message;
        if (Count > 0) {
          localStorage.setItem(prefix, JSON.stringify(Data));
          lastFetchedCollegePrefix = prefix;
          const filtered = Data.filter((item) =>
            item.Institute_Name.toLowerCase().startsWith(searchValue.toLowerCase())
          );
          setColleges(addCollegeOthers(filtered));
        } else {
          localStorage.setItem(prefix, JSON.stringify([]));
          lastFetchedCollegePrefix = prefix;
          setColleges([{ Institute_Name: "Others" }]);
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error("College fetch failed:", error);
        }
      }
    } else {
      setColleges([]);
    }
  };

  // FBP and FBC
  useEffect(() => {
    // Shorter early delays to catch the FB pixel as soon as it fires (~1-2s),
    // then fall back to longer intervals for slower connections.
    const retryDelays = [500, 1000, 2000, 3000, 3000, 3000, 3000, 3000];
    let retryCount = 0;
    let timeoutId = null;

    const getCookieValue = (cookieName) => {
      return document.cookie
        .split("; ")
        .find((row) => row.startsWith(cookieName + "="))
        ?.split("=")[1];
    };

    const captureCookies = () => {
      const fbpValue = getCookieValue("_fbp");
      const fbcValue = getCookieValue("_fbc");

      // Only update state when a value is actually found — avoids overwriting a
      // previously captured value with "" on a subsequent retry.
      if (fbpValue) setFbp(fbpValue);
      if (fbcValue) setFbc(fbcValue);

      if ((!fbpValue || !fbcValue) && retryCount < retryDelays.length) {
        timeoutId = setTimeout(captureCookies, retryDelays[retryCount]);
        retryCount++;
      }
    };

    captureCookies();
    return () => { if (timeoutId) clearTimeout(timeoutId); };
  }, []);

  // Send and verify OTP 

  const mobileNumber = watch("mobile");

  const showToast = (type, message) => {
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    document.getElementById("toastContainer").appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  };

  /* OTP Timer */
  useEffect(() => {
    if (!otpSent || otpVerified || timer === 0) return;

    const interval = setInterval(() => {
      setTimer(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [otpSent, otpVerified, timer]);

  // const handleSendOtp = async () => {
  //   if (!/^\d{10}$/.test(mobileValue)) return;

  //   try {
  //     const res = await onSendOtp(mobileValue);
  //     if (res?.data?.message?.response?.sent) {
  //       showToast("success", "OTP sent to your mobile number.");
  //       setOtpSent(true);
  //       setOtpVerified(false);
  //       setOtp("");
  //       setTimer(60);
  //     }
  //   } catch {
  //     showToast("error", "Error while sending OTP.");
  //   }
  // };

  const mainFun = async (mobile) => {
    if ("OTPCredential" in window) {
      const input = document.querySelector(
        'input[autoComplete="one-time-code"]'
      );
      if (!input) return;
      const ac = new AbortController();
      try {
        const otp = await navigator.credentials.get({
          otp: {
            transport: ["sms"],
          },
          signal: ac.signal,
        });
        input.value = otp.code;
        setTimeout(handleVerifyOtp(mobile, otp.code), 5000);
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }
  };

  // sendOTPText otp
  const handleSendOtp = async (option) => {
    const isDummyMobile = (num) => {
      if (/^(\d)\1{9}$/.test(num)) return true;
      if (/^(\d{2})\1{4}$/.test(num)) return true;
      return false;
    };
    if (
      !mobileNumber ||
      mobileNumber.length !== 10 ||
      !mobileNumber.match(/^[6-9]\d{9}$/) ||
      isDummyMobile(mobileNumber)
    ) {
      return;
    }
    if (mobileNumber.length === 10 && mobileNumber.match(/^[6-9]\d{9}$/) && !isDummyMobile(mobileNumber)) {
      let payload = { mobile: mobileNumber, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "BG", autoReadOtp: "yes" };
      const otpResponse = await callLSQLapp(payload, "OTP", param);
      if (otpResponse.data.message.response.sent) {
        // setOtpsent(true);
        showToast("success", "OTP sent to your mobile number.");
        let otpType = option === "resend" ? "resend" : "send";
        formIntermediateEventOTP(otpType);
        if (option === "resend") {
          eventWithFormInfo("resend otp", "button", "form", "", { pincode: getValues("pincode") || "na", branch: "na" });
        }
        setOtpSent(true);
        setOtpVerified(false);
        setOtp("");
        setTimer(60);
        await mainFun(mobileNumber);
      } else if (
        otpResponse.data.message.response === "MAX OTP Limit reached"
      ) {
        window.alert("OTP Limit reached, try again after 5 minutes");
        window.location.reload();
      } else {
        // notifyWarn("Please Resend OTP.");
        showToast("error", "Error while sending OTP.");
        // setDistablebtn(true);
        // setTimerDisplay("inline");
        // setTimer(30);
        // setOtpsent(false);
      }

      // setMobileval(mobileNumber);
    }
  };


  const handleVerifyOtp = async (otpValue) => {
    const otpToVerify = otpValue ?? otp;
    if (otpToVerify.length !== 6) return;
    const payload = { mobile: mobileNumber, otp: otpToVerify };
    const param = { otp: "verify", productType: "BG" };
    try {
      const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
      if (
        otpVerifyResponse?.data?.message === "Failure Occured, please check logs"
      ) {
        showToast("error", "Invalid OTP");
        setOtp("");
        return;
      }
      const tokenValue =
        otpVerifyResponse?.data?.message?.response?.dataSent?.UniqueID;
      setToken(tokenValue);
      setOtpVerified(true);

      setTimer(0);
      formIntermediateEventOTP("verified");
      showToast("success", "OTP verified successfully.");
    } catch (err) {
      console.error("OTP verification error:", err);
      showToast("error", "Error verifying OTP. Please try again.");
    }
  };



  // try {
  //   const res = await onVerifyOtp(mobileNumber, otp);
  //   if (res.data.message === "Failure Occured, please check logs") {
  //     showToast("error", "Invalid OTP");
  //   } else {
  //     setOtpVerified(true);
  //     setTimer(0);
  //     showToast("success", "OTP verified successfully.");
  //   }
  // } catch {
  //   showToast("error", "Error verifying OTP.");
  // }
  const handleChangePIN = async (e) => {
    const PIN = e.target.value;
    if (PIN.length < 6) {
      validPincodeRef.current = null;
      return;
    }
    try {
      const payload = { pincode: PIN };
      const param = { type: "SalCorpPincode" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      if (response.data.message.Count === 0) {
        validPincodeRef.current = false;
        setError("pincode", { type: "manual", message: "Enter valid pincode" });
        setSolId("");
        setPincodeData({ Branch_Name: "", City: "", State: "", State2: "", assignToDista: "", negativePincode: "" });
      } else {
        const firstBranch = response.data.message.Data[0];
        validPincodeRef.current = true;
        clearErrors("pincode");
        setSolId(firstBranch.Sol_ID);
        setPincodeData({
          Branch_Name: firstBranch.Branch_Name,
          City: firstBranch.City,
          State: firstBranch.State,
          State2: firstBranch.State2,
          // assignToDista: firstBranch.Assign_to_Dista,
        });
      }
      const salaryToSavingsCheck = await checkSalaryToSavings(e);
      if (salaryToSavingsCheck) {
        console.log("checking savings negative pincode")
        await checkSavingsNegative(e);
      } else {
        console.log("checking salary negative pincode")
        await checkNegative(e);
      }
    } catch (err) {
      console.error("Pincode validation failed:", err);
    }
  };

  async function checkNegative(e) {
    const PIN = e.target.value;
    if (PIN.length === 6) {
      const payload = { pincode: PIN };
      const param = { type: "salaryNegativePincode" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      const negativePincode = response.data.message.Data?.[0]?.Salary_Negative_Pincode ?? "";
      setPincodeData((prev) => ({ ...prev, negativePincode }));
    }
  }

   async function checkSalaryToSavings(e) {
    const PIN = e.target.value;
    if (PIN.length === 6) {
      const payload = { pincode: PIN };
      const param = { type: "salaryToSavings" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      const salaryToSavingsCheck = response.data.message.Data?.[0]?.Salary_to_Savings ?? "";
      console.log("salaryToSavingsCheck", salaryToSavingsCheck)
      setPincodeData((prev) => ({ ...prev, salaryToSavingsCheck }));
      return salaryToSavingsCheck;
    }
    return "";
  }

   async function checkSavingsNegative(e) {
    const PIN = e.target.value;
    if (PIN.length === 6) {
      const payload = { pincode: PIN };
      const param = { type: "SavingsAccountNegativePincode" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      const savingsNegativePincode =
        response.data.message.Data?.[0]?.Savings_Negative_Pincode ?? "";
      setPincodeData((prev) => ({ ...prev, savingsNegativePincode }));
    }
  }

  function convertDateFormat(dateStr) {
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  }

  function calculateAge(dobStr) {
    if (!dobStr) return "";
    const [day, month, year] = dobStr.split("/").map(Number);
    const today = new Date();
    let age = today.getFullYear() - year;
    if (
      today.getMonth() + 1 < month ||
      (today.getMonth() + 1 === month && today.getDate() < day)
    ) age--;
    return age;
  }

  const handleReset = () => {
    reset();
    setOtp("");
    setOtpSent(false);
    setOtpVerified(false);
    setTimer(60);
  };

  const onSubmit = async (data) => {
    if (!otpSent) return showToast("error", "Please send OTP.");
    if (!otpVerified) return showToast("error", "Please verify OTP.");

    // GCC check
    const employerIsOthers = gcc === "Others";
    const annualSalary = employerIsOthers ? (data.salary || "") : ""
    const isGcc = employerIsOthers
      ? "Others"
      : gcc || "Others";

    const isPpaCode = employerIsOthers ? "Others" : ppaCode || "Others";

    const isTopCorporate = employerIsOthers ? "no" : "yes";
    // const corporateTypes =
    //   employerName?.trim().toLowerCase() === "others"
    //     ? "Others"
    //     : gcc === "GCC"
    //       ? "GCC"
    //       : "Top Corporate";    // settopCorporate(isTopCorporate);
    // console.log(isTopCorporate);
    const { firstName, lastName } = getFirstNameLastName(data.fullName || "");
    setApplyBtnDisable(true);
    let combinedData = {
      name: data.fullName,
      firstname: firstName,
      lastname: lastName,
      fullName: data.fullName,
      mobile: data.mobile,
      pan: data.pan,
      employerName: employerIsOthers ? data.otherCompanyName : data.companyName,
      // email: data.email || "",
      pincode: data.pincode,
      annualIncome: annualSalary,
      gcc: isGcc,
      ppaCode: isPpaCode,
      topCorporate: isTopCorporate,
      subProduct: "SalCorp",
      interestedProduct: "Salary Account",
      ApiProductName: "SalCorp Savings Account",
      CampaignId: "832997",
      source: "Landing Page",
      CompleteUrl: window.location.href,
      User_Agent: navigator.userAgent,
      FBPixelID: fbp,
      FBClickID: fbc,
      token: token,
      otp: otp,
      isChecked: data.agreetnc,
      collegeName: data.collegeName || "",
      dob: data.dob ? convertDateFormat(data.dob) : "",
      age: calculateAge(data.dob),
      solId: solId,
      Branch_Name: pincodeData.Branch_Name || "",
      City: pincodeData.City || "",
      State: pincodeData.State || "",
      State2: pincodeData.State2 || "",
      // assignToDista: pincodeData.assignToDista || "",
      negativePincode : pincodeData.negativePincode,
      salaryToSavingsCheck: pincodeData.salaryToSavingsCheck || "",
      savingsNegPincode : pincodeData.savingsNegativePincode 
      // corporateType: corporateTypes,
    };

    // GET UTM DETAILS
    const utmParamsObj = queryString.parse(window.location.search);
    for (const [key, value] of Object.entries(utmParamsObj)) {
      combinedData[key] = value;
    }
    // console.log("combinedData", combinedData)
    if (combinedData.mobile) {
      const formattedMobile = formatAndValidateE164(combinedData.mobile);
      const hashedMobile = await hashValue(formattedMobile);
      combinedData.hashedMobile = hashedMobile
      // const formatedEmail = normalizeEmail(combinedData.workEmail);
      // const hashedEmail = await hashValue(formatedEmail)
      setValuesInLocalStorange("userData", "", hashedMobile);
    }
    let lsqInputs = getLsqLeadBody(combinedData);
    // console.log("lsqInputs", lsqInputs)

    let payload = {
      mobile: combinedData.mobile,
      otp: combinedData.otp,
      formdata: lsqInputs,
    };

    let param = { productType: "BG" };


    const encryptedPayload = await encryptBody(payload);

    const createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
    // ? IF Lead Created
    if (
      createLeadResp.data.message !== "Failure occured , please check logs"
    ) {
      let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;

      navigate(`/thankyou?id=${leadid}`);
      formSubmitEvent(combinedData, true)
    } else {
      setApplyBtnDisable(false);
      console.log("lead not created.");
      formSubmissionFailEvent();
      window.alert("Some error occured! Please try again after some time.");
      // window.location.reload();
    }
    // localStorage.setItem("formData", JSON.stringify(combinedData));
    // navigate("/thankyou");
  };

  const { onBlur: collegeRegisterOnBlur, ...collegeRegisterRest } = register("collegeName", {
    validate: (value) => {
      if (employerName?.trim().toLowerCase() === "others" && !value?.trim()) {
        return "College name is required";
      }
      return true;
    },
  });
  const collegeOnBlur = (e) => {
    collegeRegisterOnBlur(e);
    if (collegeName.trim() && !collegeSelectedFromDropdown.current) {
      setCollegeName("Others");
      setCollegeGcc("Others");
      setColleges([]);
      setValue("collegeName", "Others", { shouldValidate: true });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onInvalidSubmit)} id="myForm">
      <h2>Fill the form below</h2>

      <div className="form_wrap  name-wrap">

        {/* Full Name */}
        <div className="input_wrapper">
          <input
            placeholder="Your Full Name (as per PAN)"
            // disabled={otpVerified}
            id="fullName"
            onFocus={() => handleFieldFocus("fullName")}
            {...register("fullName", {
              required: "Full name is required",
              pattern: {
                value: /^[a-zA-Z\s]+$/,
                message: "Only alphabets allowed"
              },
              validate: (value) => {
                const trimmedValue = value ? value.trim() : "";
                if (trimmedValue.length <= 2) return "Please enter valid full name";
                if (/^([a-zA-Z]\s[a-zA-Z]{1,2}|[a-zA-Z]{2}\s[a-zA-Z])$/.test(trimmedValue)) return "Please enter valid full name";
                return true;
              }
            })}
            onInput={e => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "")}
          />
          {errors.fullName && <span className="error">{errors.fullName.message}</span>}
        </div>



        {/* Mobile */}
        <div className="otp_wrapper input_wrapper">
          <input
            type="tel"
            inputMode="numeric"
            placeholder="Your Mobile Number"
            disabled={otpVerified}
            id="mobile"
            maxLength={10}
            onFocus={() => handleFieldFocus("mobile")}
            {...register("mobile", {
              required: "Mobile number is required",
              validate: (value) => {
                if (!/^[6-9]\d{9}$/.test(value)) return "Enter a valid mobile number";
                if (/^(\d)\1{9}$/.test(value)) return "Enter a valid mobile number";
                if (/^(\d{2})\1{4}$/.test(value)) return "Enter a valid mobile number";
                return true;
              }
            })}
            onInput={(e) => {
              const val = e.target.value.replace(/\D/g, "").slice(0, 10);
              e.target.value = val;
              if (val.length > 0 && !/^[6-9]/.test(val)) {
                setError("mobile", { type: "manual", message: "Enter a valid mobile number" });
              } else if (val.length === 10 && (/^(\d)\1{9}$/.test(val) || /^(\d{2})\1{4}$/.test(val))) {
                setError("mobile", { type: "manual", message: "Enter a valid mobile number" });
              } else {
                clearErrors("mobile");
              }
            }}
          />

          {!otpVerified && !otpSent && (
            <button type="button" className="resend btn_abs" onClick={() => handleSendOtp("send")}>
              Send OTP
            </button>
          )}
          {otpSent && timer <= 0 && !otpVerified && (
            <button type="button" className="resend btn_abs" onClick={() => handleSendOtp("resend")}>
              Resend OTP
            </button>
          )}

          {errors.mobile && <span className="error">{errors.mobile.message}</span>}
        </div>

        {/* OTP */}
        {otpSent && !otpVerified && timer > 0 && (
          <div className="otp_wrapper input_wrapper">
            <input
              placeholder="Enter OTP"
              value={otp}
              id="otp"
              maxLength={6}
              inputMode="numeric"
              pattern="\d*"
              onChange={e => {
                const val = e.target.value.replace(/\D/g, "");
                setOtp(val);
                if (val.length === 6) handleVerifyOtp(val);
              }}
            />
            <span className="timer">00:{timer < 10 ? `0${timer}` : timer}</span>
          </div>
        )}
        <div className="input_wrapper">
          <input
            type="text"
            id="pan"
            placeholder="Your PAN No."
            maxLength={10}
            onFocus={() => handleFieldFocus("pan")}
            {...register("pan", {
              required: "PAN number is required",
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: "Invalid PAN format"
              }
            })}
            onInput={(e) => {
              e.target.value = e.target.value.toUpperCase();
            }}
          />

          {errors.pan && <span className="error">{errors.pan.message}</span>}
        </div>

        <div className="position-relative input_wrapper" ref={companyWrapperRef}>
          <input
            className="input-box"
            type="text"
            placeholder="Your Employer Name (Type 3+ chars for suggestions)"
            autoComplete="off"
            id="companyName"
            value={employerName}
            onFocus={() => handleFieldFocus("company")}
            {...companyRegisterProps}
            onChange={onCompanyChange}
          />
          {/* <img src="dist/img/down.svg" className="arrow" width="18" alt="arrow" /> */}
          {companies.length > 0 && (
            <ul className="companydropDown">
              {companies.map((item) => (
                <li
                  key={item.Company_Name}
                  className="company-List"
                  onMouseDown={(e) => {
                    e.preventDefault();
                    companySelectedRef.current = true;
                    if (item.Company_Name === "Others") {
                      setShowOtherInput(true);
                      setEmployerName("Others");
                      setValue("annualIncome", "")
                      // clearErrors("annualIncome");
                      setOtherCompanyName("");
                      setValue("otherCompanyName", "");
                      // clearErrors("otherCompanyName");
                      setValue("companyName", "Others", { shouldValidate: true, shouldTouch: true });
                    } else {
                      setShowOtherInput(false);
                      setEmployerName(item.Company_Name);
                      setGcc(item.GCC)
                      setPPACode(item.PPA_Code)
                      setValue("companyName", item.Company_Name, { shouldValidate: true, shouldTouch: true });
                      setValue("otherCompanyName", "");
                      setValue("salary", "");
                      setOtherCompanyName("");
                      setCollegeName("");
                      setValue("collegeName", "");
                      setColleges([]);
                      collegeSelectedFromDropdown.current = false;
                      setValue("dob", "");
                    }
                    setCompanies([]);
                    setValue("companyName", item.Company_Name);
                  }}
                >
                  {item.Company_Name}
                </li>
              ))}
            </ul>
          )}
          {showOtherInput && (
            <>
              {/* Other Employer Name */}
              <div className="input_wrapper">
                <input
                  id="otherCompanyName"
                  type="text"
                  placeholder="Enter Other Employer Name"
                  onFocus={() => handleFieldFocus("otherCompanyName")}
                  {...register("otherCompanyName", {
                    required: "Employer name is required",
                    pattern: {
                      value: /^[a-zA-Z0-9\s.-]+$/,
                      message: "Only alphabets allowed",
                    },
                    minLength: {
                      value: 2,
                      message: "Enter valid company name",
                    },
                  })}
                />
                {errors.otherCompanyName && (
                  <span className="error">{errors.otherCompanyName.message}</span>
                )}
              </div>

              {/* Salary */}
              <div className="input_wrapper">
                <input
                  id="salary"
                  type="text"
                  placeholder="Take Home Salary Per Month"
                  onFocus={() => handleFieldFocus("salary")}
                  {...register("salary", {
                    required: "Salary is required",
                    validate: (value) => {
                      const num = Number(value.replace(/,/g, ""));
                      if (isNaN(num)) return "Enter valid amount";
                      if (num <= 0) return "Salary must be greater than 0";
                      return true;
                    },
                    onChange: (e) => {
                      let value = e.target.value.replace(/,/g, "");
                      if (value !== "" && !isNaN(value)) {
                        e.target.value = new Intl.NumberFormat("en-IN").format(value);
                      } else if (value === "") {
                        e.target.value = "";
                      }
                    },
                  })}
                  onKeyDown={(e) => {
                    if (
                      !/[\d\b]/.test(e.key) &&
                      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                    ) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.salary && (
                  <span className="error">{errors.salary.message}</span>
                )}
              </div>

              {/* Select your Graduate / Postgraduate college */}
              <div className="input_wrapper position-relative">
                <input
                  type="text"
                  placeholder="Select your Graduate / Postgraduate college"
                  autoComplete="off"
                  id="collegeName"
                  value={collegeName}
                  style={{ paddingRight: "36px" }}
                  onFocus={() => handleFieldFocus("collegeName")}
                  {...collegeRegisterRest}
                  onBlur={collegeOnBlur}
                  onChange={(e) => {
                    setValue("collegeName", e.target.value);
                    onCollegeChange(e);
                  }}
                />
                <img src="dist/img/down.svg" className="arrow" width="18" alt="arrow" />
                {colleges.length > 0 && (
                  <ul className="companydropDown">
                    {colleges.map((item) => (
                      <li
                        key={item.Institute_Name}
                        className="company-List"
                        onMouseDown={(e) => {
                          e.preventDefault();
                          setCollegeName(item.Institute_Name);
                          setCollegeGcc(item.Institute_Name === "Others" ? "Others" : "");
                          setValue("collegeName", item.Institute_Name, { shouldValidate: true });
                          setColleges([]);
                          collegeSelectedFromDropdown.current = true;
                        }}
                      >
                        {item.Institute_Name}
                      </li>
                    ))}
                  </ul>
                )}
                {errors.collegeName && (
                  <span className="error">{errors.collegeName.message}</span>
                )}
              </div>

              {/* Date of Birth */}
              <div className="input_wrapper">
                <input
                  type="text"
                  inputMode="numeric"
                  id="dob"
                  placeholder="Your Date of Birth (DD/MM/YYYY)"
                  maxLength={10}
                  onFocus={() => handleFieldFocus("dob")}
                  {...register("dob", {
                    required: "Date of birth is required",
                    validate: (value) => {
                      const match = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
                      if (!match) return "Enter valid Date of Birth";
                      const [, dayStr, monthStr, yearStr] = match;
                      const day = parseInt(dayStr, 10);
                      const month = parseInt(monthStr, 10);
                      const year = parseInt(yearStr, 10);
                      if (day < 1 || day > 31) return "Enter valid Date of Birth";
                      if (month < 1 || month > 12) return "Enter valid Date of Birth";
                      if (year < 1920 || year > 2015) return "Enter valid Date of Birth";
                      const date = new Date(year, month - 1, day);
                      if (
                        date.getFullYear() !== year ||
                        date.getMonth() + 1 !== month ||
                        date.getDate() !== day
                      ) return "Enter valid Date of Birth";
                      return true;
                    },
                  })}
                  onInput={(e) => {
                    const digits = e.target.value.replace(/\D/g, "").slice(0, 8);
                    let formatted = digits;
                    if (digits.length > 4) {
                      formatted = digits.slice(0, 2) + "/" + digits.slice(2, 4) + "/" + digits.slice(4);
                    } else if (digits.length > 2) {
                      formatted = digits.slice(0, 2) + "/" + digits.slice(2);
                    }
                    e.target.value = formatted;

                    // Real-time validation
                    const day = parseInt(digits.slice(0, 2), 10);
                    const month = digits.length >= 4 ? parseInt(digits.slice(2, 4), 10) : null;
                    const year = digits.length === 8 ? parseInt(digits.slice(4, 8), 10) : null;

                    let errorMsg = "";
                    if (digits.length >= 2 && (day < 1 || day > 31)) {
                      errorMsg = "Enter valid Date of Birth";
                    } else if (month !== null && (month < 1 || month > 12)) {
                      errorMsg = "Enter valid Date of Birth";
                    } else if (year !== null) {
                      if (year < 1920 || year > 2015) {
                        errorMsg = "Enter valid Date of Birth";
                      } else {
                        const date = new Date(year, month - 1, day);
                        if (
                          date.getFullYear() !== year ||
                          date.getMonth() + 1 !== month ||
                          date.getDate() !== day
                        ) errorMsg = "Enter valid Date of Birth";
                      }
                    }

                    if (errorMsg) {
                      setError("dob", { type: "manual", message: errorMsg });
                    } else {
                      clearErrors("dob");
                    }
                  }}
                />
                {errors.dob && (
                  <span className="error">{errors.dob.message}</span>
                )}
              </div>
            </>
          )}
        </div>


        {/* Work Email
        <div className="input_wrapper">
          <input
            type="text"
            placeholder="Enter Work Email"
            id="email"
            list="email-options"
            autoComplete="off"
            value={email}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value:
                  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Enter valid email",
              },
              onChange: (e) => {
                setEmail(() => e.target.value);
                setIsEmailEmpty(false);
                const data = e.target.value;
                if (data.includes(".com") || data.includes("co.in")) {
                  setIsEmailEmpty(true);
                } else {
                  setIsEmailEmpty(false);
                }
              },
            })}
          />
          {email.length > 2 ? (
            !isEmailEmpty ? (
              <datalist id="email-options">
                <option value={`${email}@gmail.com`}></option>
                <option value={`${email}@yahoo.com`}></option>
                <option value={`${email}@rediffmail.com`}></option>
                <option value={`${email}@yahoo.co.in`}></option>
                <option value={`${email}@icloud.com`}></option>
                <option value={`${email}@outlook.com`}></option>
              </datalist>
            ) : null
          ) : null}
          {errors.email && <span className="error">{errors.email.message}</span>}
        </div>
        */}

        {/* Pin Code */}
        <div className="input_wrapper">
          <input
            type="text"
            placeholder="Your PIN Code (Office)"
            maxLength={6}
            id="pincode"
            onFocus={() => handleFieldFocus("pincode")}
            {...register("pincode", {
              required: "PIN code is required",
              pattern: {
                value: /^\d{6}$/,
                message: "Enter a valid 6-digit PIN code",
              },
              validate: (value) =>
                value?.length !== 6 ||
                validPincodeRef.current === true ||
                "Enter valid pincode",
              onChange: handleChangePIN,
            })}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
          />
          {errors.pincode && (
            <span className="error">{errors.pincode.message}</span>
          )}
        </div>

        {/* Terms */}
        <div className="terms input_wrapper mt-3">
          <Controller
            name="agreetnc"
            control={control}
            rules={{ required: "Please accept our terms and conditions by clicking on the checkbox." }}
            render={({ field }) => (
              <input
                type="checkbox"
                id="agreetnc"
                checked={field.value}
                onFocus={() => handleFieldFocus("agreetnc")}
                onChange={e => {
                  field.onChange(e.target.checked);
                  eventWithFormInfo("terms & conditions", "checkbox", "form", "", { pincode: getValues("pincode") || "na", branch: "na" });
                }}
              />
            )}
          />
          <label htmlFor="agreetnc">
            I consent to be contacted by ICICI Bank regarding this product via Call/ SMS/ Email/ WhatsApp/ RCS. I accept ICICI Bank’s <a href="https://www.icici.bank.in/content/dam/icicibank/india/managed-assets/docs/terms-condition/tnc-savings-account.pdf?ITM=nli_termsConditions_termsConditions_na_na_11_na_na_NLI" target="_blank" rel="noreferrer" onClick={() => eventClick("terms & conditions", "link", "form")}>Terms &amp; Conditions</a>.
          </label>
        </div>
        {errors.agreetnc && <span className="error" style={{ fontFamily: "Mulish, sans-serif", fontWeight: 600 }}>{errors.agreetnc.message}</span>}

        {/* <button type="button" className="reset" onClick={handleReset}>
          Reset Details
        </button> */}

        <button type="submit"
          disabled={disableApplyBtn}
          className="proceed"
          style={{
            backgroundColor: disableApplyBtn ? "grey" : "",
          }}>
          {disableApplyBtn ? "Submitting..." : "Apply Now"}
        </button>


        <div id="toastContainer" className="toast-container" />
      </div>
    </form>
  );
}

export default FormComponent;
